export default __webpack_public_path__ + "a75efaa094b72d73cee1ef3a00791d37.svg";